import React from 'react'
import { InputContainer } from '../../../../../../common/components/form/form.module'
import { InputLabelContainer } from '../../../../../../common/components/form/label/containers/input-label.container'

export default function PayoutsBasicInfoComponent({
  handleInnerFormChange,
  selectedPayout,
  onClose,
  handleFormSubmit
}: any) {

  return (
    <>
      <div className="flex justify-center items-center w-[600px]">
        <div className="w-full max-w-lg p-2 bg-white shadow-md rounded-md">
          <h1 className="text-xl font-bold mb-4 text-center">{selectedPayout?.Id ? "Edit Payout" : "Add New Payout"}</h1>
          <div className="flex flex-col gap-4">
          <InputContainer
              label="Orer Id"
              name="order_id"
              onValueChange={(event: any) => {
                handleInnerFormChange({
                  value: event.target.value,
                  path:'order_id',
                })
              }}
              type="text"
              value={selectedPayout?.order_id}
            />
            <InputContainer
              label="Collector"
              name="collector_app_id"
              onValueChange={(event: any) => {
                handleInnerFormChange({
                  value: event.target.value,
                  path:'collector_app_id',
                })
              }}
              type="text"
              value={selectedPayout?.collector_app_id}
            />
            <InputContainer
              label="Receiver"
              name="receiver_app_id"
              onValueChange={(event: any) => {
                handleInnerFormChange({
                  value: event.target.value,
                  path: 'receiver_app_id',
                })
              }}
              type="text"
              value={selectedPayout?.receiver_app_id}
            />
          
            <InputContainer

              label="Type"
              name="type"
              onValueChange={(event: any) => {
                handleInnerFormChange({
                  value: event.target.value,
                  path: 'Payout.type',

                })
              }}
              type="text"
              value={selectedPayout?.Payout?.type}
            />
          </div>
          <div className="flex justify-end mt-6">
            <button
              onClick={onClose}
              type="button"
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
            >
              Close
            </button>
            <button
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
              onClick={handleFormSubmit}
              type="submit"
            >
              Save
            </button>
          </div>
        </div>
      </div>

    </>
  )
}